import React, { useState } from 'react'
import { Edit,Trash } from 'lucide-react'
import CustomModal from '../../ui/CustomModal'
import { useTranslation } from 'react-i18next'
import { StoreSubType } from '../../../types/modules/admin/storeType.type'
import { useUpdateResource } from '../../../hooks/useUpdateResource'
import UpdateStoreSubTypeForm from './UpdateStoreSubTypeForm'
import { formatNumber } from '../../../utils/formatNumber'

type Props ={
    subType:StoreSubType
}

function StoreSubTypeItem({subType}:Props) {
        const [isOpen, setIsOpen] = useState(false);
        const {t}= useTranslation();
        const enName = subType.languages.find(s=>s.languageCode==="en")?.name ||"";
        const arName = subType.languages.find(s=>s.languageCode==="ar")?.name ||"";

        const {updateResource} = useUpdateResource();
        async function handleDelete(){
            await  updateResource(`subtype/${subType.id}`, {},"admin",{
                method: "DELETE",
                successMessage: t("deleted_success"),
                invalidateQueries:["store-sub-types-by-admin"],
                confirmMessage:t("confirm_delete")
              });
        }

  return (
    <>
        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
        {formatNumber(subType.id)}
        </td>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
        {enName}
        </td>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
            {arName}
        </td>


        <td className="p-3 min-w-[200px] text-Black font-normal  flex gap-2">
        <button onClick={()=>setIsOpen(p=>!p)}>
            <Edit/>
        </button>
        <button onClick={handleDelete} className=' text-Red'>
            <Trash/>
        </button>
        </td>
        <CustomModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={t('update_information')}
        >
        <UpdateStoreSubTypeForm
        id={subType.id}
        defaultValues={{
            languages: [
            { languageCode: "en", title: enName },
            { languageCode: "ar", title: arName },
            ],
        }}
        onSubmitSuccess={()=>{
            setIsOpen(p=>false)
        }}
        />

        </CustomModal>
    </>
  )
}

export default StoreSubTypeItem